import { ShopifyIcon, Ideal360Icon } from 'components/CustomIcons';

export const PROVIDERS_ICONS_MAP = {
  Shopify: ShopifyIcon,
  Ideal360: Ideal360Icon,
};
